<template>
  <div>
    <v-form ref="form"
            v-model="valid"
    >
      <v-card style="padding: 20px">
        <v-card-title>Custom User Group</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newUserGroup"
            autofocus
            label="Name"
            :rules="[rules.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <div class="row row--end">
            <v-btn text
                   @click="$emit('cancel')"
            >Cancel </v-btn>
            <v-btn
              text
              @click="createUserGroup"
              color="primary"
              :disabled="!valid"
            >Add user group
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { HubConnection } from "@microsoft/signalr";
export default {
  name:  "AddUserGroupForm",
  props: {
    connection: HubConnection,
  },
  data: function() {
    return {
      valid:        false,
      newUserGroup: "",
      rules:        {
        required: (value) => !!value || "Required",
      },
    };
  },
  methods: {
    createUserGroup() {
      this.connection
        .invoke("AddUserGroup", this.newUserGroup)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("groups-updated", response.entity);
            this.$emit("ok");
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((response) => {
          this.$emit("failure", response);
        });
    },
  },
};
</script>

<style scoped></style>
